import APIS from "../../constant/EndPoint";
import NACell from "../Reusable/DataTable/NACell";
import SwitchButton from "../Reusable/SwitchButton";
//@ts-ignore
import { AccessControl } from "@careinfo/permission-required";
import EditIcon from "../../Icons/EditIcon";
import DataTable from "../Reusable/DataTable";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import { useState } from "react";
import Button from "../Reusable/Button";
import Modal from "../Reusable/Modal";
import SyncContact from "./SyncContact";
import usePermission from "../../customHooks/usePermission";
import { useNavigate } from "react-router-dom";

const StaffList = (props: any) => {
  const { handleIsActive, profile } = props;
  const [openSyncContactPopUp, setOpenSyncContactPopup] = useState(false);
  const { isSuperUser } = usePermission();
  const navigate = useNavigate();
  const canEditStaff = usePermission({
    allowedPermissions: ["can_update_staff"],
  });
  const handleRowClick = (row: any) => {
    if (!canEditStaff) return;
    navigate(`edit/${row?.original?.id}`);
  };
  const defaultColumns: any = [
    {
      header: "Full Name",
      accessorKey: "name",
      cell: NACell,
    },
    {
      header: "Email",
      accessorKey: "email",
      cell: NACell,
    },
    {
      header: "Mobile Number",
      accessorKey: "mobile_number",
      cell: NACell,
    },
    {
      header: "Branch",
      accessorKey: "default_branch.name",
      cell: NACell,
    },
    {
      header: "Active",
      accessorKey: "is_active",
      cell: ({ row, getValue }) => (
        <div onClick={(e) => e.stopPropagation()}>
          <AccessControl
            children={
              <SwitchButton
                id={row?.original?.id}
                value={getValue()}
                disabled={false}
                onChange={handleIsActive}
              />
            }
            allowedPermissions={["can_update_staff"]}
            renderNoAccess={
              <SwitchButton
                id={row?.original?.id}
                value={getValue()}
                disabled={true}
                onChange={handleIsActive}
              />
            }
          />
        </div>
      ),
    },
  ];

  return (
    <>
      <DataTable
        url={APIS.USER}
        queryKey={"staff"}
        params={{ is_staff: true }}
        columns={defaultColumns}
        tableName={"staff-list"}
        onRowClick={handleRowClick}
        addNewPagePath={"create"}
        actionMenu={
          <>
            <div className={tw`flex items-center justify-end w-full `}>
              <div className={tw`w-24`}>
                <Button
                  label={"Sync Contact"}
                  type="button"
                  onClick={() => setOpenSyncContactPopup(true)}
                />
              </div>
            </div>
          </>
        }
      />
      <Modal
        title={"Sync Contact"}
        isOpen={openSyncContactPopUp}
        setIsOpen={setOpenSyncContactPopup}
      >
        <SyncContact setOpenSyncContactPopup={setOpenSyncContactPopup} />
      </Modal>
    </>
  );
};

export default StaffList;
